module.exports = __webpack_public_path__ + "img/code.8a2e1f78.svg";